import { action, observable } from 'mobx';
import URLS from '../../Constant/urls';
import * as loginUtil from '../../Utils/loginUtil';
import { SearchResultStoreModel } from './index';
import { fetch } from '../../Utils/fetch';
import { qav } from '../../Utils/qav';
class HasShare {
    // 有分享单 alert 是否可见
    @observable
    public hasShareAlertVisiable = false;

    // 有分享单 alert title
    @observable
    public hasShareAlertTitle = '';

    public abort: any = null;
    public rootStore: SearchResultStoreModel;

    public constructor(rootStore: SearchResultStoreModel) {
        this.rootStore = rootStore;
    }
    @action
    public showShareAlert = (title: string) => {
        this.hasShareAlertVisiable = true;
        this.hasShareAlertTitle = title;
        qav({
            page: this.rootStore.pageName,
            module: 'shareAlert',
            path: [{ title: '订单共享提示弹窗展示', position: '0' }],
            operType: 'show'
        });
    };

    @action
    public hideHasShareAlert = () => {
        this.hasShareAlertVisiable = false;
    };

    public checkHasShare = async () => {
        if (await loginUtil.isLogin()) {
            this.abort && this.abort();
            try {
                const response = await fetch(
                    {
                        url: URLS.hasShareOrder,
                        method: 'post',
                        requestType: 'form'
                    },
                    (abort: any) => {
                        this.abort = abort;
                    },
                    this.rootStore.hyId
                );
                const { status, data } = response;

                if (status === 0 && data > 0) {
                    this.showShareAlert(`您有${data}张订单来自朋友的共享`);
                }
            } catch (err) {
                // console.log()
            } finally {
                this.abort = null;
            }
        }
    };

    public bindShare = async () => {
        try {
            const response = await fetch({
                url: URLS.bindShare,
                method: 'post',
                requestType: 'form'
            },
            (abort: () => any) => {},
            this.rootStore.hyId);
            const { status } = response;

            if (status === 0) {
                this.rootStore.orderlist.scrollTopAndInit();
            }
        } catch (err) {
            // console.log()
        }
    };
}

export default HasShare;
